import {requestHeader, request} from "./api";

const {REACT_APP_API_KEY_PROD_OXXO, REACT_APP_API_KEY_PROD_DEV, REACT_APP_ENV, REACT_APP_API_KEY_PROD_AIRMILES, REACT_APP_API_KEY_PROD_FOODPANDA} = process.env
let apiKeyAdmin = null;

switch (REACT_APP_ENV) {
    case 'OXXO':
        apiKeyAdmin = REACT_APP_API_KEY_PROD_OXXO;
        break;
    case 'AIRMILES':
        apiKeyAdmin = REACT_APP_API_KEY_PROD_AIRMILES;
        break;
    case 'FOODPANDA':
        apiKeyAdmin = REACT_APP_API_KEY_PROD_FOODPANDA;
        break;
    case 'DEV':
        apiKeyAdmin = REACT_APP_API_KEY_PROD_DEV;
        break;
    default:
        apiKeyAdmin = REACT_APP_API_KEY_PROD_FOODPANDA;
}

export const getCommitedGame = (game) => {
    return request(`/games/${game.id}/commit`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': apiKeyAdmin
        },
        body: JSON.stringify({
            gameId: game.id,
            shopperId: game.shopperId,
        }),
    });
};

export const create = (data) => {
    return request(`/games`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': apiKeyAdmin
        },
        body: JSON.stringify({
            ...data
        }),
    });
};

export const deleteAllGames = () => {
    return request(`/admin/games/`, {
        method: 'DELETE',
    });
};
//this request here because of token
export const getUsersBenefits = (userId, size = 5, page = 0) => {
    return request(`/benefits?shopperId=${userId}&size=${size}&page=${page}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': apiKeyAdmin
        },
    });
};
export const getUsersBenefitsHeaders = (userId, size = 1000000, page = 0) => {
    return requestHeader(`/admin/prizes?shopperId=${userId}&size=${size}&page=${page}`, {
        method: 'GET',
    });
};

export const assignPrizeManually = (obj) => {
    return request(`/admin/prizes/assign`, {
        method: 'POST',
        body: JSON.stringify(obj)
    })
}

export const getUsersCommitedTotal = (userId) => {
    return request(`/benefits/count?shopperId=${userId}&status=COMMITTED`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': apiKeyAdmin
        },
    });
};

